/**
 * MedicationVideoEmbed — web
 *
 * Same tap-to-play facade as the native sibling, but mounts a YouTube <iframe>
 * instead of a react-native-webview (which doesn't exist on web).
 */
import { useState } from "react";
import { View, Text, Pressable, Image } from "react-native";
import { Play } from "lucide-react-native";
import { EMBER } from "../../onboarding/theme";
import { youTubeEmbedUrl, youTubeThumbnail } from "./medicationVideo";

import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";
import { semanticColors } from "@louise/theme/tokens";
export function MedicationVideoEmbed({
  videoId,
  label,
}: {
  videoId: string;
  label: string;
}) {
  const capturePress = usePressCapture("MedicationVideoEmbed");
  const [playing, setPlaying] = useState(false);

  return (
    <View>
      <View
        style={{
          width: "100%",
          aspectRatio: 16 / 9,
          borderRadius: 14,
          overflow: "hidden",
          backgroundColor: "#000",
        }}
      >
        {playing ? (
          <iframe
            src={youTubeEmbedUrl(videoId)}
            title={label}
            style={{ width: "100%", height: "100%", border: 0 }}
            allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
            allowFullScreen
          />
        ) : (
          <Pressable
            onPress={() => {
              capturePress(pressLabel(label), "play_medication_video");
              setPlaying(true);
            }}
            accessibilityRole="button"
            accessibilityLabel={label}
            style={{ flex: 1 }}
          >
            <Image
              source={{ uri: youTubeThumbnail(videoId) }}
              style={{ width: "100%", height: "100%" }}
              resizeMode="cover"
            />
            <View
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <View
                style={{
                  width: 56,
                  height: 56,
                  borderRadius: 28,
                  backgroundColor: semanticColors.overlay.scrim,
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Play
                  size={24}
                  color={semanticColors.onDark.text.primary}
                  fill={semanticColors.onDark.text.primary}
                />
              </View>
            </View>
          </Pressable>
        )}
      </View>
      {label ? (
        <Text
          className="font-dm-sans"
          style={{
            fontSize: 13,
            color: EMBER.colors.textMid,
            marginTop: 8,
          }}
        >
          {label}
        </Text>
      ) : null}
    </View>
  );
}
